export { default } from "./DeliveryItem.component";
